import AccountActionTypes from 'app/account/ActionTypes';
import reducer from 'app/account/reducer';
import routes from 'app/account/routes';

export default {
  reducers: {
    account: reducer,
  },
  actionTypes: AccountActionTypes,
  routes,
};
